import AddIcon from '@mui/icons-material/Add';
import { CustomTitle } from './styles';
import {
  Menu,
  Grid,
  Button,
  MenuItem,
  Container,
  CircularProgress,
} from '@mui/material';
import { useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const LoadingIcon = () => (
  <CircularProgress sx={{ color: 'white' }} size={16} />
);

export const Root = ({ children, limitWidth = false, ...props }) => {
  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{
        maxWidth: limitWidth ? 'calc(1296px - 2rem)' : 'calc(100% - 12rem)',
      }}
      {...props}>
      <Grid
        container
        width="100%"
        marginTop="2vh"
        alignItems="center"
        padding={2}>
        {children}
      </Grid>
    </Container>
  );
};

export const InnerContainer = ({ children, ...props }) => {
  return (
    <Grid container marginTop={4} {...props}>
      {children}
    </Grid>
  );
};

export const Title = ({ children }) => (
  <Grid item xs={8}>
    <CustomTitle>{children}</CustomTitle>
  </Grid>
);

export const IconButton = ({ onClick, children, Icon = AddIcon, ...props }) => (
  <Grid item display="flex" justifyContent="flex-end" xs={4}>
    <Button
      sx={{
        height: '45px',
        minWidth: '155px',
        borderRadius: '8px',
        color: '#fff',
        backgroundColor: '#1462A5',
        '&:hover': {
          background: '#124572',
        },
        boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
        fontSize: '16px',
        fontWeight: '400',
      }}
      onClick={onClick}
      variant="contained"
      startIcon={<Icon />}
      {...props}>
      {children}
    </Button>
  </Grid>
);

export const OptionsButton = ({
  disabled,
  loading,
  options = [],
  label,
  Icon = KeyboardArrowDownIcon,
  ...props
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = event => {
    if (disabled) return;
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Grid item display="flex" justifyContent="flex-end" xs={4}>
      <Button
        sx={{
          height: '45px',
          minWidth: '155px',
          borderRadius: '8px',
          color: '#fff',
          textTransform: 'none',
          backgroundColor: '#1462A5',
          '&:hover': {
            background: '#124572',
          },
          boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
          fontSize: '16px',
          fontWeight: '400',
        }}
        variant="contained"
        aria-controls={open ? 'menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        endIcon={loading ? <LoadingIcon /> : <Icon />}
        {...props}>
        {label}
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {options.map((option, index) => (
          <MenuItem
            key={index}
            onClick={() => {
              handleClose();
              option?.onClick();
            }}>
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </Grid>
  );
};
